import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Icon, TypoGraph } from 'components/ui'
import { Button } from 'components/form'
import strings from 'l10n'
import styles from './ErrorPage.module.scss'

type ErrorPageProps = {
  isChunkLoad: boolean
}

const ErrorPage = ({ isChunkLoad }: ErrorPageProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const lastPathRef = useRef(location.pathname)

  useEffect(() => {
    lastPathRef.current = location.pathname
  }, [location.pathname])
  const title = isChunkLoad ? strings.ERROR_CHUNK_LOAD_HEADER : strings.ERROR_BOUNDARY_HEADER
  const message = isChunkLoad ? strings.ERROR_CHUNK_LOAD_BODY : strings.ERROR_BOUNDARY_BODY

  const handleRefresh = () => {
    window.location.reload()
  }

  const handleGoBack = () => {
    const beforeNavigation = lastPathRef.current
    navigate(-1)

    setTimeout(() => {
      if (lastPathRef.current === beforeNavigation) {
        navigate('/', { replace: true })
      }
    }, 100)
  }

  return (
    <div className={styles.errorBoundary}>
      <div className={styles.card}>
        <Icon
          name={isChunkLoad ? 'icon_update_page' : 'icon_no_connection'}
          boxClassName={styles.illustration}
          iconClassName={styles.illustrationIcon}
          width={isChunkLoad ? 185 : 180}
          height={isChunkLoad ? 148 : 120}
        />
        <TypoGraph
          variant="h5"
          align="center"
          className={styles.title}
          component="h1"
          gutterBottom={false}
          paragraph={false}
        >
          {title}
        </TypoGraph>
        <TypoGraph
          variant="body1"
          align="center"
          className={styles.message}
          component="p"
          gutterBottom={false}
          paragraph={false}
        >
          {message}
        </TypoGraph>
        <div className={styles.actions}>
          <Button
            label={strings.ERROR_BOUNDARY_REFRESH}
            onClick={handleRefresh}
            variant="contained"
            startIcon="icon_refresh"
            startIconColor="#ffffff"
            className={styles.primaryAction}
            tooltipClassName={styles.actionTooltip}
          />
          {!isChunkLoad && (
            <Button
              label={strings.ERROR_BOUNDARY_GO_BACK}
              onClick={handleGoBack}
              variant="outlined"
              startIcon="icon_go_back"
              className={styles.secondaryAction}
              tooltipClassName={styles.actionTooltip}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ErrorPage
